import React from "react";
import Hero from "./components/Hero";
import Works from "./components/Works";
import Info from "./components/Info";
import CallToAction from "./components/CallToAction";
import Yo from "./images/yo2.jpg";
import ScrollToTopOnMount from "./components/utilities/ScrollToTopOnMount";

const Dashboard = () => {
  return (
    <>
      <ScrollToTopOnMount />

      <Hero />
      <Works titulo={"Ultimos trabajos"} numeroDeElementos={6} />
      <Info
        imagen={Yo}
        texto="Cuando no estoy aprendiendo de desarrollo web me encanta investigar temas financieros"
      />
      <CallToAction />
    </>
  );
};

export default Dashboard;
